export default __webpack_public_path__ + "static/media/5.bd21a8c1.jpg";